// extracted by mini-css-extract-plugin
export default {"container__wrap":"Layout_container__wrap__e64un"};